import React from 'react';
import { Card, CardMedia, CardContent, Typography, Button, Box, Grid } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StarIcon from '@mui/icons-material/Star';

const RecommendationCard = ({ rec, onCardClick, onReviewButtonClick }) => {
  const handleReviewClick = (e) => {
    e.stopPropagation();
    onReviewButtonClick(rec.show.uniqueId);
  };

  return (
    <Card sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          height="300"
          image={rec.show.posterUrl}
          alt={rec.show.title}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={11}>
              <Button
                variant="outlined"
                sx={{ color: 'white', borderColor: 'white' }}
                style={{ borderRadius: '20px', fontSize: '0.8rem' }}
                fullWidth
                startIcon={<VisibilityIcon />}
                size='small'
                onClick={(e) => {
                  e.stopPropagation();
                  onCardClick(rec);
                }}>
                Ver detalles
              </Button>
            </Grid>
            <Grid item xs={11}>
              <Button
                variant="outlined"
                sx={{ color: 'white', borderColor: 'white' }}
                style={{ borderRadius: '20px', fontSize: '0.8rem' }}
                fullWidth
                size='small'
                startIcon={<DoneAllIcon />}
                onClick={handleReviewClick}>
                Ya la vi
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <CardContent onClick={(e) => { onCardClick(rec); }} sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <Typography gutterBottom variant="body1" component="div">
          {rec.show.title}
        </Typography>
        <Box sx={{ width: '100%', mt: 'auto' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1, flexDirection: 'column' }}>
            <Typography variant="body2" color="text.secondary">
              {rec.reviews.positive.count} {rec.reviews.positive.count === 1 ? 'persona' : 'personas'} de tu círculo {rec.reviews.positive.count === 1 ? 'recomienda' : 'recomiendan'} esto
            </Typography>
          </Box>
          {rec.reviews.positive.critics_count > 0 &&  
          <Box sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                {rec.reviews.positive.critics_count} 
              </Typography>
              <StarIcon color="secondary" sx={{ ml: 1 }} />
            </Box>
          }
        </Box>
      </CardContent>
    </Card>
  );
};

export default RecommendationCard;
